<script lang="ts">
  import type { Component } from "svelte";
  import { domId } from "../../lib/dom";
  import RadioGroup from "../../components/RadioGroup.svelte";
  import CloseButton from "../../components/CloseButton.svelte";

  let {
    answer,
    back,
    inactive,
    dateOfBirth,
    dateOfBirthLocalized,
    nextStep,
  }: {
    answer: ({ nextStep, status }) => void;
    back: () => void | null;
    inactive: boolean;
    dateOfBirth: string;
    dateOfBirthLocalized: string;
    nextStep: Component;
  } = $props();

  let dateOfBirthInput = $state(dateOfBirth);
  let warning = $state(null);
  let error = $state(null);
  let selectedOption = $state(dateOfBirth === null ? "changed" : null);

  function handleContinue() {
    verifyDateInput();
    if (allowContinue()) {
      error = null;
      answer({ nextStep, status: selectedOption });
    }
  }

  function allowContinue() {
    return (
      selectedOption === "unchanged" ||
      (selectedOption === "changed" && dateOfBirthInput && !error)
    );
  }

  function verifyDateInput() {
    if (selectedOption === "changed") {
      const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD format to compare with the date input
      error = null;
      warning = null;
      if (dateOfBirth === dateOfBirthInput) {
        error =
          "Please enter a different date from the original one you provided";
      } else if (dateOfBirthInput > today) {
        error = "Are you sure? This date is in the future";
      }
    }
  }

  const dateOfBirthId = domId("date-of-birth");
</script>

<div class="h-full">
  <fieldset class="ui-fieldset" class:hidden={dateOfBirth === null}>
    <legend>
      <span>Were you born on <b>{dateOfBirthLocalized}</b>?</span>
    </legend>

    <RadioGroup
      name="date_of_birth[status]"
      options={[
        ["Yes", "unchanged"],
        ["No", "changed"],
      ]}
      bind:group={selectedOption}
    />
  </fieldset>

  <fieldset class="ui-fieldset" class:hidden={selectedOption !== "changed"}>
    <legend>What is your date of birth?</legend>

    <input
      id={dateOfBirthId}
      type="date"
      name="date_of_birth[date]"
      class="ui-input"
      disabled={selectedOption !== "changed"}
      bind:value={dateOfBirthInput}
    />
    {#if error}<div class="ui-error">{error}</div>{/if}
  </fieldset>
</div>

<div class="floating-footer">
  {#if back}
    <button type="button" class="btn btn-ghost" onclick={back}>Back</button>
  {:else}
    <CloseButton />
  {/if}
  <button
    type="submit"
    class="btn btn-primary"
    onclick={handleContinue}
    disabled={!selectedOption || inactive}>Continue</button
  >
</div>
